import RequestForQuotation from './RequestForQuotationContainer';

export default RequestForQuotation;
